function isAbsoluteUrl(url) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
}
export {
  isAbsoluteUrl
};
//# sourceMappingURL=isAbsoluteUrl.mjs.map